import { render, staticRenderFns } from "./title-btn.vue?vue&type=template&id=36439728&scoped=true"
import script from "./title-btn.vue?vue&type=script&lang=js"
export * from "./title-btn.vue?vue&type=script&lang=js"
import style0 from "./title-btn.vue?vue&type=style&index=0&id=36439728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36439728",
  null
  
)

export default component.exports